import {
  animate,
  animateChild,
  query,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  inject,
} from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { BadgeModule } from 'primeng/badge';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { MenuModule } from 'primeng/menu';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { PanelMenu, PanelMenuModule } from 'primeng/panelmenu';
import { TagModule } from 'primeng/tag';
import { UserAvatarComponent } from '../user-avatar/user-avatar.component';

export interface ILayoutConfig {
  fullWidth?: boolean;
}

export interface ILayoutUser {
  name: string;
  email: string;
  group?: { name?: string; master?: boolean };
  twoFactorEnabled?: boolean;
}

@Component({
  selector: 'kon-layout',
  standalone: true,
  imports: [
    CommonModule,
    OverlayPanelModule,
    RouterModule,
    UserAvatarComponent,
    MenuModule,
    PanelMenuModule,
    ButtonModule,
    DialogModule,
    BadgeModule,
    TagModule,
  ],
  animations: [
    trigger('Show', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('300ms ease', style({ opacity: 1 })),
      ]),
      transition(':leave', [
        style({ opacity: 1 }),
        animate('300ms ease', style({ opacity: 0 })),
      ]),
    ]),
    trigger('Slide', [
      transition(':enter', [
        style({ transform: 'translateX(-100%)' }),
        animate('300ms ease-in-out', style({ transform: 'translateX(0)' })),
      ]),
      transition(':leave', [
        style({ transform: 'translateX(0)' }),
        animate('300ms ease-in-out', style({ transform: 'translateX(-100%)' })),
      ]),
    ]),
    trigger('AnimateChild', [
      transition('* => void', [
        query('@*', [animateChild()], { optional: true }),
      ]),
    ]),
  ],
  templateUrl: './layout.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LayoutComponent implements OnInit {
  @Input({ required: true }) user!: ILayoutUser;
  @Input() sidebarItems: MenuItem[] | null = [];
  @Input() settingsItems: MenuItem[] | null = [];
  @Input() userMenuItems: MenuItem[] = [];
  @Input() notificationsMenuItems: MenuItem[] = [];
  @Input() unreadNotificationsCount = 0;
  @Input() config: ILayoutConfig = {};
  @Input() title?: string | null = null;
  @Input() backRoute?: string[] | null = null;
  @Input() version?: string | null = null;
  @Output() bellClick = new EventEmitter<void>();
  @ViewChild('settingsMenu') settingsMenu: PanelMenu | undefined;

  supportDialogVisible = false;

  openSupportDialog() {
    this.supportDialogVisible = true;
  }

  mobileMenuOpen = false;
  router = inject(Router);

  ngOnInit(): void {
    this.router.events.subscribe(() => {
      this.closeMobileMenu();
    });
  }

  openMobileMenu() {
    this.mobileMenuOpen = true;
  }

  closeMobileMenu() {
    this.settingsMenu?.collapseAll();
    this.mobileMenuOpen = false;
  }

  toggleMobileMenu() {
    this.mobileMenuOpen = !this.mobileMenuOpen;
  }
}
